<template>
  <LeadStatusesPage
    :title="__('Status concluído', 'settings')"
    :description="__('status que definem uma lead como concluída', 'settings')"
    param-id="lead_statuses_completed"
  />
</template>

<script>
import LeadStatusesPage from "@/components/Lead/Statuses/LeadStatusesPage.vue";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  components: {
    LeadStatusesPage,
  },
};
</script>
